import { AxiosError, isAxiosError as baseIsAxiosError } from 'axios';

export interface AxiosErrorResponse {
  error: {
    message: string;
  };
}

export function isAxiosError<Response = unknown>(
  // eslint-disable-next-line
  error: Error | unknown
): error is AxiosError<Response> {
  return baseIsAxiosError<Response>(error);
}
